// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1w-A7","col":"styles_col__2bzVL"};